import { Button, makeStyles, tokens } from '@fluentui/react-components'
import React, { useRef, useState, useEffect } from 'react'
import { Dismiss20Filled } from '@fluentui/react-icons'
import { t } from '../../../i18n/i18n'

type FullscreenRenderProps = {
   enterFullscreen: () => void
   exitFullscreen: () => void
   isFullscreen: boolean
}
const useStyles = makeStyles({
   fullScreenDiv: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      boxSizing: 'border-box',
      backgroundColor: tokens.colorNeutralBackground1,
   },
   exitBtn: {
      position: 'absolute',
      top: tokens.spacingVerticalL,
      right: tokens.spacingHorizontalL,
   },
})

type FullscreenProps = {
   children: (props: FullscreenRenderProps) => JSX.Element
}

export const Fullscreen = ({ children }: FullscreenProps) => {
   const myDivRef = useRef(null)
   const [isFullscreen, setIsFullscreen] = useState(false)
   const classes = useStyles()

   const enterFullscreen = () => {
      if (myDivRef.current) {
         if (myDivRef.current.requestFullscreen) {
            myDivRef.current.requestFullscreen()
         } else if (myDivRef.current.mozRequestFullScreen) {
            myDivRef.current.mozRequestFullScreen()
         } else if (myDivRef.current.webkitRequestFullscreen) {
            myDivRef.current.webkitRequestFullscreen()
         } else if (myDivRef.current.msRequestFullscreen) {
            myDivRef.current.msRequestFullscreen()
         }
      }
   }

   const exitFullscreen = () => {
      if (document.exitFullscreen) {
         document.exitFullscreen()
      }
   }

   useEffect(() => {
      const handleFullscreenChange = () => {
         setIsFullscreen(!!document.fullscreenElement)
      }

      document.addEventListener('fullscreenchange', handleFullscreenChange)

      return () => {
         document.removeEventListener('fullscreenchange', handleFullscreenChange)
      }
   }, [])

   return (
      <div ref={myDivRef} className={classes.fullScreenDiv}>
         {isFullscreen && (
            <Button className={classes.exitBtn} size="large" icon={<Dismiss20Filled />} iconPosition="after" onClick={exitFullscreen} appearance="subtle">
               {t('ExitFullScreen')}
            </Button>
         )}

         {children({ enterFullscreen, exitFullscreen, isFullscreen })}
      </div>
   )
}
